import * as React from 'react';

import Frame from '../Frame';
import type { EmbedProps as Props } from '.';

function Typeform(props: Props) {
  return <Frame {...props} src={props.attrs.href} title="Typeform Embed" />;
}

// Static method to check if the URL matches the Typeform embed pattern
Typeform.isMatch = (href: string) => {
  const urlRegex = /^https:\/\/([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)\.typeform\.com\/to\/(.*)$/;

  return urlRegex.test(href);
};

export default Typeform;
